import React, {FC} from "react"

import GenericModal from "@irati/ui/src/GenericModal"
import History from "@irati/utils/history"
import {H2, H6} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"

interface Data {
  title: string,
  content: string,
  buttonText: string,
  show: boolean
}

interface Props{
  data: Data
}

const GenericErrorModal: FC<Props> = ({data}) => {
  const {title, content, buttonText} = data
  const onClose = () => {
    History.push("wallet/flexi-reward")
  }

  return (
    <GenericModal
      hideActions
      show
      onHide={onClose}>
      <H2 marginBottom={2}>
        <FormattedMessage id={title} />
      </H2>
      <H6 marginTop={3} marginBottom={5}>
        <FormattedMessage id={content} />
      </H6>

      <Button full primary onClick={onClose}>
        <FormattedMessage id={buttonText} />
      </Button>

    </GenericModal>
  )
}

export default GenericErrorModal
